var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.images.length > 0
    ? _c("div", { staticClass: "project-images-galery" }, [
        _vm.data.images.length == 1
          ? _c("div", { staticClass: "row project-image-container" }, [
              _c(
                "div",
                { staticClass: "col-12 widescreen big" },
                [
                  _vm.isExist(_vm.data.images[0].webImage)
                    ? _c("img", {
                        staticClass: "abs-center",
                        attrs: { src: _vm.data.images[0].webImage, alt: "" },
                        on: {
                          load: _vm.loaded,
                          click: function($event) {
                            return _vm.onShowModalGallery(0, true)
                          }
                        }
                      })
                    : _vm._e(),
                  _c("BadgesComponent", {
                    attrs: {
                      badgesData: _vm.getBadgesData(),
                      projectId: _vm.project.id
                    }
                  })
                ],
                1
              )
            ])
          : _c("div", { staticClass: "row project-image-container" }, [
              _c(
                "div",
                { staticClass: "col-8 widescreen big pr-1" },
                [
                  _vm.isExist(_vm.data.images[0].webImage)
                    ? _c("img", {
                        staticClass: "abs-center",
                        attrs: {
                          src: _vm.data.images[0].thumbnailImage,
                          alt: ""
                        },
                        on: {
                          load: _vm.loaded,
                          click: function($event) {
                            return _vm.onShowModalGallery(0, true)
                          }
                        }
                      })
                    : _vm._e(),
                  _c("BadgesComponent", {
                    attrs: {
                      badgesData: _vm.getBadgesData(),
                      projectId: _vm.project.id
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "col-4 pl-1 pr-0" }, [
                _c("div", { staticClass: "row" }, [
                  _vm.images.length > 1
                    ? _c("div", { staticClass: "col-12 widescreen" }, [
                        _c("p", { staticClass: "text-center pb-2" }, [
                          _vm.isExist(_vm.data.images[1].thumbnailImage)
                            ? _c("img", {
                                staticClass: "abs-center",
                                attrs: {
                                  src: _vm.data.images[1].thumbnailImage,
                                  alt: ""
                                },
                                on: {
                                  load: _vm.loaded,
                                  click: function($event) {
                                    return _vm.onShowModalGallery(1, true)
                                  }
                                }
                              })
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm.images.length > 2
                    ? _c("div", { staticClass: "col-12 widescreen pb-1" }, [
                        _c("a", { staticClass: "a-count-container" }, [
                          _vm.images.length > 3
                            ? _c("div", { staticClass: "counter-container" }, [
                                _c("span", [
                                  _vm._v("+" + _vm._s(_vm.images.length - 3))
                                ])
                              ])
                            : _vm._e(),
                          _vm.isExist(_vm.data.images[2].thumbnailImage)
                            ? _c("img", {
                                staticClass: "abs-center",
                                attrs: {
                                  src: _vm.data.images[2].thumbnailImage,
                                  alt: ""
                                },
                                on: {
                                  load: _vm.loaded,
                                  click: function($event) {
                                    return _vm.onShowModalGallery(2, true)
                                  }
                                }
                              })
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }